/** @jsxImportSource theme-ui */
import { Box, Grid } from 'theme-ui';
import { Formik, useFormikContext } from 'formik';
import qs from 'qs';
import { nanoid } from 'nanoid';
import { useEffect } from 'react';
import { SetURLSearchParams, useSearchParams } from 'react-router-dom';
import { GrayFormikField } from '@/components/GrayFormikField';
import { DiscountAgreementStatusEnum } from '@/types/types';

const discountAgreementStatusOptions = Object.entries(DiscountAgreementStatusEnum)
    .filter(entry => !isNaN(parseInt(entry[0])))
    .map(entry => ({
        value: entry[0],
        label: entry[1].toString()
    }));

type FilterValues = {
    DiscountAgreementStatus: unknown;
};

const FilterAgreements: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const parsedParams = qs.parse(searchParams.toString());
    const initialValues: FilterValues = {
        DiscountAgreementStatus: DiscountAgreementStatusEnum.Published,
        ...parsedParams,
    };

    return (
        <Formik initialValues={initialValues} enableReinitialize onSubmit={() => {}}>
            <>
                <Grid
                    sx={{
                        '@media (width > 700px)': {
                            gridTemplateColumns: 'minmax(200px, 1fr) minmax(200px, 1fr) minmax(200px, 1fr)',
                        },
                    }}
                >
                    <Box>
                        <GrayFormikField
                            label="Discount agreeement status"
                            type="select"
                            name="DiscountAgreementStatus"
                            options={discountAgreementStatusOptions}
                        />
                    </Box>
                </Grid>
                <SyncStatusToSearchParams
                    currentStatus={parsedParams.DiscountAgreementStatus}
                    setSearchParams={setSearchParams}
                />
            </>
        </Formik>
    );
};

type SyncStatusToSearchParamsProps = {
    currentStatus: unknown;
    setSearchParams: SetURLSearchParams;
};

const SyncStatusToSearchParams = ({
    currentStatus,
    setSearchParams,
}: SyncStatusToSearchParamsProps) => {
    const { values } = useFormikContext<FilterValues>();

    useEffect(() => {
        const isInSyncWithUrl = String(values.DiscountAgreementStatus) === String(currentStatus);
        if (isInSyncWithUrl) {
            return;
        }
        const isSeedingEmptyUrl = currentStatus === undefined;
        setSearchParams(qs.stringify({ ...values, rand: nanoid(6) }), {
            replace: isSeedingEmptyUrl,
        });
    }, [values.DiscountAgreementStatus]);

    return null;
};

export default FilterAgreements;
